import { SERIAL_STATUSES } from '@sahab/contracts'
import { z } from 'zod'

export const SERIAL_PAGE_SIZES = [25, 50, 100] as const

/**
 * The serial number lookup (`/serials`): the number searched, its status and warehouse, the page.
 * "Where is S/N …?" is a search, so the box leads.
 */
export const serialSearchSchema = z.object({
  q: z.string().trim().max(100).optional().catch(undefined),
  status: z.enum(SERIAL_STATUSES).optional().catch(undefined),
  warehouseId: z.uuid().optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  pageSize: z
    .number()
    .int()
    .refine((v) => (SERIAL_PAGE_SIZES as readonly number[]).includes(v))
    .optional()
    .catch(undefined),
})
export type SerialSearch = z.infer<typeof serialSearchSchema>
